import { Translations } from '../model'

export default {
  'filter.label.stations.all': 'All Stations',
  'filter.label.stations.favorites': 'My Favorites',
  'filter.label.stations.recently_played': 'Recently played',
  'filter.label.stations.most_played': 'Most played'
} as Translations
